import React, { useState } from 'react';
import FileUpload from "./components/FileUpload";
import { create as ipfsHttpClient } from "ipfs-http-client";
const fs = require("fs");

export function getAPI(component) 
{
    switch (component) {
        case "FileUpload":
            return new FileUploadComponentAPI();
    }
}


export class FileUploadComponentAPI 
{
    getComponent = () => FileUpload;
    
    addToIpfs = (file, component) => 
    {
        const convertToImportCandidate = (file) =>
            fs.promises.readFile(file.filepath)
                .then((data) => ({ content: data, mode: "file" }));

        const configurations = component.configurations;
        const projectData = 
            configurations.projectId + ":" + configurations.projectSecret;

        const getIpfsClient = () => ipfsHttpClient({
            url: configurations.apiURL,
            headers: {
                authorization: `Basic ${btoa(projectData)}`
            }
        });

        return convertToImportCandidate(file)
            .then((importCandidate) => getIpfsClient().add(importCandidate))
            .then((added) => ({ path: added.path }));
    };
}
